/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PeopleDetailsPage from './people.details.page';
import { fetchUser, fetchStudyInformation } from '../../actions/actions';

export const mapStateToProps = (state, ownProps) => {
  return {
    user: state.peopleDetails.user,
    isFetching: state.peopleDetails.isFetching || state.subject.isFetchingStudy,
    error: state.peopleDetails.error || state.subject.error,
    study: state.subject.participantStudy
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchUser: (userId) => {
      dispatch(fetchUser(userId));
    },

    fetchStudy: (studyGid) => {
      dispatch(fetchStudyInformation(studyGid));
    }
  };
};

const PeopleDetailsPageContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(PeopleDetailsPage));

export default PeopleDetailsPageContainer;
